'use client'

import { MouseEvent } from 'react'
import { useRouter } from 'next/navigation'
import Button from '@dustin-web/microsite-components/src/button'
import { scrollToTabs } from '../../product-page.utils'

type Props = {
  href: string
  text: string
  className?: string
}

const ScrollToTabsButton = ({ href, text, className }: Props) => {
  const router = useRouter()

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    router.push(href, { scroll: false })

    scrollToTabs()
  }

  return <Button link className={className} onClick={handleClick} href={href} text={text} />
}

export default ScrollToTabsButton
